<div
  class="info-tool d-flex flex-column position-relative"
  cdkOverlayOrigin
  #tooltipOrigin="cdkOverlayOrigin"
  (mouseenter)="isTooltipOpen = true"
  (mouseleave)="isTooltipOpen = false"
>
  <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="tooltipOrigin"
  [cdkConnectedOverlayOpen]="isTooltipOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="false"
>
  <div
    class="tooltip-info shadow-md"
    (mouseenter)="isTooltipOpen = true"
    (mouseleave)="isTooltipOpen = false"
  >

  <div class="d-flex justify-content-start mt-4 ml-4">
    <img src="../../../assets/icons/search-result/hotel/01_flecha.svg" style="width: 15px;" alt="">
  </div>

    <div style="position: relative">

    <table class="table-info-tool">
      <tr>
        <th class="px-4" style="text-align: center">
          <div class="d-flex align-items-center" style="min-height: 45px;border-bottom: 1px solid #ececec;">
            <p class="mb-0" style="text-transform: capitalize;color: #ffffff">Impuestos</p>
          </div>
        </th>
      </tr>

      <ng-container *ngIf="taxesIncluded.length > 0">
        <tr>
          <td class="px-4 pt-3 pb-1">
            <p class="mb-0 tax-group-label">Incluido en el precio</p>
          </td>
        </tr>
        <tr *ngFor="let tax of taxesIncluded">
          <td class="d-flex align-items-center px-4" style="height: 32px;">
            <p class="mb-0">
              <span class="tax-description">{{ tax.description }}</span>
            </p>
          </td>
        </tr>
      </ng-container>

      <ng-container *ngIf="taxesExcluded.length > 0">
        <tr>
          <td class="px-4 pt-3 pb-1">
            <p class="mb-0 tax-group-label">Pagar en destino</p>
          </td>
        </tr>
        <tr *ngFor="let tax of taxesExcluded">
          <td class="d-flex align-items-center justify-content-between px-4" style="height: 32px; gap: 12px;">
            <p class="mb-0">
              <span class="tax-description">{{ tax.description }}</span>
              <span class="tax-amount">&nbsp;&nbsp;{{ tax.currency || currency }} {{ tax.amount | number: '1.2-2' }}</span>
            </p>
          </td>
        </tr>
      </ng-container>

      <!-- Tarifa neta (opcional, ver item-status.component.html) -->
      <!-- <ng-container *ngIf="netTotal">
        <tr>
          <td class="px-4 pt-3 pb-1">
            <p class="mb-0 tax-group-label">Tarifa neta</p>
          </td>
        </tr>
        <tr>
          <td class="px-4" style="height: 32px;">
            <p class="mb-0">
              <span class="tax-amount">{{ netTotal.agencyCurrency }} {{ netTotal.amountConverted | number: '1.2-2' }}</span>
            </p>
            <p class="mb-0 net-total-original" *ngIf="netTotal.originalCurrency !== netTotal.agencyCurrency">
              {{ netTotal.originalCurrency }} {{ netTotal.amountOriginal | number: '1.2-2' }}
            </p>
          </td>
        </tr>
      </ng-container> -->
    </table>

    <!-- Valor por noche (opcional, ver item-status.component.html) -->
    <div *ngIf="dailyPrices && dailyPrices.length > 0" class="px-4 pb-3 pt-2">
      <p class="mb-2 tax-group-label">Valor por noche</p>
      <usb-carousel [items]="dailyPrices" [mobileItemsPerView]="2" [desktopItemsPerView]="3" style="--usb-carousel-arrow-size: 22px;">
        <ng-template #slideTemplate let-day>
          <div class="daily-price-slide">
            <p class="mb-0 daily-price-day">{{ getDayName(day.date) }}</p>
            <p class="mb-0 daily-price-date">{{ day.date }}</p>
            <p class="mb-0 daily-price-amount">{{ day.currency }} {{ day.price | number: '1.2-2' }}</p>
          </div>
        </ng-template>
      </usb-carousel>
    </div>

    </div>
  </div>
</ng-template>
